"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get populateSamplePayload () {
        return populateSamplePayload;
    },
    get populateSamplePayloadV2 () {
        return populateSamplePayloadV2;
    },
    get populateSamplePayloadView () {
        return populateSamplePayloadView;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _uuid = require("uuid");
const _models = require("~/models");
const _webhookHelpers = require("~/helpers/webhookHelpers");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
async function populateSamplePayload(context, viewOrModel, includeNested = false, operation = 'insert') {
    const out = {};
    let columns = [];
    let model;
    if (viewOrModel instanceof _models.View) {
        const viewColumns = await viewOrModel.getColumns(context);
        for (const col of viewColumns){
            if (col.show) columns.push(await _models.Column.get(context, {
                colId: col.fk_column_id
            }));
        }
        model = await viewOrModel.getModel(context);
        await model.getColumns(context);
    } else if (viewOrModel instanceof _models.Model) {
        columns = await viewOrModel.getColumns(context);
        model = viewOrModel;
    }
    for (const column of columns){
        var _model_primaryKey;
        if (!includeNested && [
            _nocodbsdk.UITypes.LinkToAnotherRecord,
            _nocodbsdk.UITypes.Lookup
        ].includes(column.uidt)) continue;
        if (operation === 'delete' && ((_model_primaryKey = model.primaryKey) == null ? void 0 : _model_primaryKey.title) !== column.title) continue;
        out[column.title] = await getSampleColumnValue(context, column);
    }
    return out;
}
async function populateSamplePayloadView(context, param) {
    const { viewOrModel, includeUser = false, user, version = 'v2' } = param;
    const { operation = 'insert' } = param;
    let columns = [];
    let model;
    if (viewOrModel instanceof _models.View) {
        const viewColumns = await viewOrModel.getColumns(context);
        for (const col of viewColumns){
            if (col.show) columns.push(await _models.Column.get(context, {
                colId: col.fk_column_id
            }));
        }
        model = await viewOrModel.getModel(context);
        await model.getColumns(context);
    } else if (viewOrModel instanceof _models.Model) {
        columns = await viewOrModel.getColumns(context);
        model = viewOrModel;
    }
    await model.getViews(context);
    const sampleUser = includeUser ? user || {
        id: 'usr_sample_user_id',
        email: 'user@example.com',
        display_name: 'Sample User',
        user_name: 'sample_user',
        roles: 'user'
    } : null;
    const samplePayload = _extends({
        type: `view.after.${operation}`,
        id: (0, _uuid.v4)()
    }, includeUser && _utils.isEE && sampleUser ? {
        user: (0, _webhookHelpers.sanitizeUserForHook)(sampleUser)
    } : {}, version === 'v3' ? {
        version
    } : {}, {
        data: {
            table_id: model.id,
            table_name: model.title
        }
    });
    // TODO: generate sample payload for view
    samplePayload.data = _extends({}, samplePayload.data);
    return samplePayload;
}
async function populateSamplePayloadV2(context, viewOrModel, includeNested = false, operation = 'insert', scope = 'records', includeUser = false, user, version = 'v2') {
    const rows = {};
    let columns = [];
    let model;
    if (viewOrModel instanceof _models.View) {
        const viewColumns = await viewOrModel.getColumns(context);
        for (const col of viewColumns){
            if (col.show) columns.push(await _models.Column.get(context, {
                colId: col.fk_column_id
            }));
        }
        model = await viewOrModel.getModel(context);
        await model.getColumns(context);
    } else if (viewOrModel instanceof _models.Model) {
        columns = await viewOrModel.getColumns(context);
        model = viewOrModel;
    }
    await model.getViews(context);
    if ((0, _nocodbsdk.ncIsString)(operation) && version === 'v3') {
        operation = operation.replace('bulk', '').toLowerCase();
    }
    const sampleUser = includeUser ? user || {
        id: 'usr_sample_user_id',
        email: 'user@example.com',
        display_name: 'Sample User',
        user_name: 'sample_user',
        roles: 'user'
    } : null;
    const samplePayload = _extends({
        type: `${scope}.after.${operation}`,
        id: (0, _uuid.v4)()
    }, includeUser && _utils.isEE && sampleUser ? {
        user: (0, _webhookHelpers.sanitizeUserForHook)(sampleUser)
    } : {}, version === 'v3' ? {
        version
    } : {}, {
        data: {
            table_id: model.id,
            table_name: model.title
        }
    });
    for (const column of columns){
        if (!includeNested && [
            _nocodbsdk.UITypes.LinkToAnotherRecord,
            _nocodbsdk.UITypes.Lookup
        ].includes(column.uidt)) continue;
        rows[column.title] = await getSampleColumnValue(context, column);
    }
    let prevRows;
    if ([
        'update',
        ...version === 'v2' ? [
            'bulkUpdate'
        ] : []
    ].includes(operation)) {
        prevRows = rows;
    }
    samplePayload.data = _extends({}, samplePayload.data, prevRows && {
        previous_rows: [
            prevRows
        ]
    }, operation !== 'bulkInsert' && rows && {
        rows: [
            rows
        ]
    }, operation === 'bulkInsert' && rows && {
        row_inserted: 10
    });
    return samplePayload;
}
async function getSampleColumnValue(context, column) {
    switch(column.uidt){
        case _nocodbsdk.UITypes.ID:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
            {
                const colOpt = await column.getColOptions(context);
                const sampleVal = await populateSamplePayload(context, await colOpt.getRelatedTable(context));
                if (colOpt.type !== _nocodbsdk.RelationTypes.BELONGS_TO) {
                    return undefined;
                }
                return colOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO ? sampleVal : [
                    sampleVal
                ];
            }
            break;
        case _nocodbsdk.UITypes.ForeignKey:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.Lookup:
            {
                const colOpt = await column.getColOptions(context);
                const relColOpt = await colOpt.getRelationColumn(context).then((r)=>r.getColOptions(context));
                const { refContext } = relColOpt.getRelContext(context);
                const sampleVal = await getSampleColumnValue(context, await colOpt.getLookupColumn(refContext));
                return relColOpt.type === _nocodbsdk.RelationTypes.BELONGS_TO ? sampleVal : [
                    sampleVal
                ].flat();
            }
            break;
        case _nocodbsdk.UITypes.SingleLineText:
            {
                return 'Sample Text';
            }
            break;
        case _nocodbsdk.UITypes.LongText:
            {
                return 'Sample Long text';
            }
            break;
        case _nocodbsdk.UITypes.Attachment:
            {
                return [
                    {
                        url: 'https://nocodb.com/dummy.png',
                        title: 'image.png',
                        mimetype: 'image/png',
                        size: 0
                    }
                ];
            }
            break;
        case _nocodbsdk.UITypes.Checkbox:
            {
                return true;
            }
            break;
        case _nocodbsdk.UITypes.MultiSelect:
            {
                var _colOpt_, _column_dtxp_split_, _column_dtxp_split, _column_dtxp;
                const colOpt = await column.getColOptions(context);
                return (colOpt == null ? void 0 : (_colOpt_ = colOpt[0]) == null ? void 0 : _colOpt_.title) || (column == null ? void 0 : (_column_dtxp = column.dtxp) == null ? void 0 : (_column_dtxp_split = _column_dtxp.split(',')) == null ? void 0 : (_column_dtxp_split_ = _column_dtxp_split[0]) == null ? void 0 : _column_dtxp_split_.replace(/^['"]|['"]$/g, ''));
            }
            break;
        case _nocodbsdk.UITypes.SingleSelect:
            {
                var _colOpt_1, _column_dtxp_split_1, _column_dtxp_split1, _column_dtxp1;
                const colOpt = await column.getColOptions(context);
                return (colOpt == null ? void 0 : (_colOpt_1 = colOpt[0]) == null ? void 0 : _colOpt_1.title) || (column == null ? void 0 : (_column_dtxp1 = column.dtxp) == null ? void 0 : (_column_dtxp_split1 = _column_dtxp1.split(',')) == null ? void 0 : (_column_dtxp_split_1 = _column_dtxp_split1[0]) == null ? void 0 : _column_dtxp_split_1.replace(/^['"]|['"]$/g, ''));
            }
            break;
        case _nocodbsdk.UITypes.Date:
            {
                return new Date();
            }
            break;
        case _nocodbsdk.UITypes.Year:
            {
                return 2000;
            }
            break;
        case _nocodbsdk.UITypes.Time:
            {
                return '11:00';
            }
            break;
        case _nocodbsdk.UITypes.PhoneNumber:
            {
                return '0000000000';
            }
            break;
        case _nocodbsdk.UITypes.Email:
            {
                return 'test@nocodb.com';
            }
            break;
        case _nocodbsdk.UITypes.URL:
            {
                return 'https://nocodb.com';
            }
            break;
        case _nocodbsdk.UITypes.Number:
            {
                return 123;
            }
            break;
        case _nocodbsdk.UITypes.Decimal:
            {
                return 123.1;
            }
            break;
        case _nocodbsdk.UITypes.Currency:
            {
                return '$123';
            }
            break;
        case _nocodbsdk.UITypes.Percent:
            {
                return '10';
            }
            break;
        case _nocodbsdk.UITypes.Duration:
            {
                return 123;
            }
            break;
        case _nocodbsdk.UITypes.Rating:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.Formula:
            {
                return 'Sample Output';
            }
            break;
        case _nocodbsdk.UITypes.Rollup:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.Count:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.DateTime:
            {
                return new Date();
            }
            break;
        case _nocodbsdk.UITypes.CreatedTime:
            {
                return new Date();
            }
            break;
        case _nocodbsdk.UITypes.LastModifiedTime:
            {
                return new Date();
            }
            break;
        case _nocodbsdk.UITypes.AutoNumber:
            {
                return 1;
            }
            break;
        case _nocodbsdk.UITypes.Geometry:
            {
                return {};
            }
            break;
        case _nocodbsdk.UITypes.JSON:
            {
                return '{}';
            }
            break;
        case _nocodbsdk.UITypes.SpecificDBType:
            {
                return null;
            }
            break;
        case _nocodbsdk.UITypes.User:
            {
                return [
                    {
                        id: 'u8z87rijgdsrpzdrbqsw',
                        email: 'user@example.com',
                        display_name: 'User',
                        meta: {
                            icon: {
                                url: 'https://cdn.mysite.example/image/sAlPwL3wqYPg74H7TMPb.webp',
                                title: 'sAlPwL3wqYPg74H7TMPb.webp',
                                mimetype: 'image/webp',
                                size: 26662,
                                width: 270,
                                height: 370,
                                signedUrl: 'https://cdn.mysite.example/image/sAlPwL3wqYPg74H7TMPb.webp',
                                data: ''
                            },
                            iconType: 'IMAGE'
                        }
                    }
                ];
            }
            break;
        case _nocodbsdk.UITypes.GeoData:
            {
                return '51.50073334463501;-0.12462623347869291';
            }
            break;
    }
}
